import React from "react";
import CustomDatePickerInput from "./CustomDatePickerInput";

interface ICustomStudentScheduleDate {
  source: string;
  label?: string;
  referenceSource: any;
  includeDates?: IIncludeDates[];
  excludeDates?: IExcludeDates[];
}

const validateScheduleDate = (referenceSource: any) => {
  if (referenceSource === undefined) {
    return;
  }

  let now = new Date();

  // check if date.time Now inside of early Registration Dates
  // if true, will use startDate academic year as minimum date value
  // else, date.time Now will add 14 days.
  if (
    now.getTime() >=
      new Date(referenceSource.earlyRegistrationStartDate).getTime() &&
    now.getTime() <=
      new Date(referenceSource.earlyRegistrationEndDate).getTime()
  ) {
    return referenceSource.startDate;
  }

  now.setDate(now.getDate() + 14);
  let dateNowPlusFourteen = now.getTime();

  // if date.time Now + 14 days before lateRegistrationStartDate
  // will use lateRegistrationStartDate as minimum date value
  // else will use date.time Now + 14 days as minimum date value
  if (
    dateNowPlusFourteen <
    new Date(referenceSource.lateRegistrationStartDate).getTime()
  ) {
    return referenceSource.lateRegistrationStartDate;
  }

  return new Date(dateNowPlusFourteen).toISOString().slice(0, 10);
};

const disabledInput = (referenceSource: any) => {
  if (referenceSource === undefined) {
    return true;
  }

  let now = new Date();
  now.setDate(now.getDate() + 11);

  // input will disable when date.time Now + 11 days not in early Registration Date
  if (
    new Date(referenceSource.earlyRegistrationStartDate).getTime() >
    now.getTime()
  ) {
    return true;
  }

  return false;
};

const CustomStudentScheduleDateInput = ({
  source,
  label,
  referenceSource,
  includeDates,
  excludeDates,
}: ICustomStudentScheduleDate) => {
  return (
    <>
      <CustomDatePickerInput
        name={source}
        label={label}
        min={validateScheduleDate(referenceSource)}
        max={referenceSource ? referenceSource.endDate : ""}
        disableValue={disabledInput(referenceSource)}
        placeholderValue={
          disabledInput(referenceSource) ? "Select Academic Year first." : ""
        }
        includeDates={includeDates}
        excludeDates={excludeDates}
        isWeekDays
      />
    </>
  );
};

export default CustomStudentScheduleDateInput;
